var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcoFuncaoSubstituir(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico-funcao-substituir",
    transform: "translate(-868 -865)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_2207",
    "data-name": "Grupo 2207",
    transform: "translate(20.578 37)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "folder-2",
    transform: "translate(852.421 836.001)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1268",
    "data-name": "Grupo 1268",
    transform: "translate(0 18.988) rotate(-90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1267",
    "data-name": "Grupo 1267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755",
    "data-name": "Caminho 755",
    d: "M5.724,4.293V0L0,5.724l5.724,5.724V7.155a5.731,5.731,0,0,1,5.724,5.724v2.862h2.862V12.88A8.6,8.6,0,0,0,5.724,4.293Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1269",
    "data-name": "Grupo 1269",
    transform: "translate(39.956 14.957) rotate(90)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Grupo_1267-2",
    "data-name": "Grupo 1267"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Caminho_755-2",
    "data-name": "Caminho 755",
    d: "M5.724,4.293V0L0,5.724l5.724,5.724V7.155a5.731,5.731,0,0,1,5.724,5.724v2.862h2.862V12.88A8.6,8.6,0,0,0,5.724,4.293Z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_171",
    "data-name": "Ret\\xE2ngulo 171",
    transform: "translate(20.579 -0.001)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 17,
    height: 12,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 16,
    height: 11,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Ret\\xE2ngulo_172",
    "data-name": "Ret\\xE2ngulo 172",
    transform: "translate(19.946 33.947) rotate(180)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 18.044,
    height: 11.633,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 17.044,
    height: 10.633,
    fill: "none"
  })))), /*#__PURE__*/React.createElement("rect", {
    id: "Ret\\xE2ngulo_448",
    "data-name": "Ret\\xE2ngulo 448",
    width: 50,
    height: 50,
    transform: "translate(868 865)",
    fill: "none"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoFuncaoSubstituir);
export default __webpack_public_path__ + "static/media/ico-funcao-substituir.c989d4fb0a68ac87dd362410ca3f37fc.svg";
export { ForwardRef as ReactComponent };